import Vue from 'vue'
import axios from '../api/axios'

const errorHandler = error => {
  const msg = `${window.location.href}\n${error.message}\n${encodeURIComponent(error.stack)}`
  // eslint-disable-next-line
  if (process.env.VUE_APP_EXCEPTION_NOTIFICATION === 'true') {
    axios.post(`/error/log?category=web&version=${process.env.VUE_APP_VERSION}`, msg)
  } else {
    console.error(msg)
  }
}
if(process.env.VUE_APP_ENV !== 'development') {
  Vue.config.errorHandler = errorHandler
}